export default __webpack_public_path__ + "static/media/modal_close.8907ab12.svg";